module.exports = __webpack_public_path__ + "img/moto.edeb7820.png";